import type { Observable as ObservableType } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-fetch';
import type { ClassicEpicColor, ServerColor } from '@atlassian/jira-issue-epic-color';

export interface Epic {
	id: number;
	key: string;
	summary: string;
	issueTypeDetails: {
		id: string;
		name: string;
		iconUrl: string;
		hierarchyLevel: number;
	};
	color?: ServerColor;
	epicColor?: ClassicEpicColor;
	projectId?: number;
}

// This is only a partial representation of the response

export interface LoadIssueParentsRestResponse {
	epics: {
		values: Array<Epic>;
	};
}

export function loadIssueParents(boardId: string): ObservableType<LoadIssueParentsRestResponse> {
	return fetchJson$<LoadIssueParentsRestResponse>(
		`/rest/greenhopper/1.0/xboard/plan/v2/backlog/epics.json?rapidViewId=${boardId}`,
	);
}
